import { Link } from "react-router-dom";
import { ArrowUpRight, Sparkles } from "lucide-react";
import { Navigation } from "./Navigation";
import { cn } from "@tsi/ui";

interface SidebarProps {
  embedded?: boolean;
  onNavigate?: () => void;
}

export function Sidebar({ embedded, onNavigate }: SidebarProps) {
  return (
    <aside
      className={cn(
        embedded
          ? "block"
          : "hidden h-[calc(100vh/var(--zoom,1)-3.5rem)] w-[240px] shrink-0 border-r border-border/70 bg-background md:sticky md:top-14 md:block"
      )}
    >
      <div className="flex h-full flex-col p-3 pt-5">
        <Navigation onNavigate={onNavigate} />

        {/* Bottom card — boas-vindas + CTA pro simulador */}
        <div className="mt-auto">
          <div className="relative overflow-hidden rounded-xl border border-brand-800 bg-linear-to-br from-brand-700 via-brand to-brand-800 p-4 text-white shadow-card">
            <div className="absolute -right-6 -top-6 h-24 w-24 rounded-full bg-brand-green/30 blur-2xl" />
            <div className="absolute -bottom-8 -left-6 h-20 w-20 rounded-full bg-brand-400/30 blur-2xl" />
            <div className="relative">
              <div className="inline-flex items-center gap-1 rounded-full border border-white/15 bg-white/10 px-2 py-0.5 text-[10px] font-medium uppercase tracking-wider text-white/80 backdrop-blur">
                <Sparkles className="h-2.5 w-2.5" />
                Bem-vindo
              </div>
              <div className="mt-2 text-[14px] font-semibold leading-snug">
                Pronto pra montar uma proposta?
              </div>
              <p className="mt-1 text-[11.5px] leading-snug text-white/70">
                Combine cartas do estoque, coloque a comissão do parceiro e gere o PDF em segundos.
              </p>
              <Link
                to="/simulador"
                className="mt-3 inline-flex items-center gap-1 text-[12px] font-medium text-white hover:text-white/80"
              >
                Simule agora <ArrowUpRight className="h-3 w-3" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
}
